<template>
  <div class="d-inline-flex">
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="getExcel()" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">far fa-file-excel</v-icon> 
      Exportar
    </v-btn>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {excelCustomers} from '@/api/customers'
import moment from 'moment'

export default {
  name: "ExportCustomers",
  props: ['filters', 'options', 'disabled', 'search'],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async getExcel() {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sort = ''
      if (sortBy && sortBy[0] == 'seller') {
        sort = 'seller__first_name'
      } else {
        sort = (sortBy && sortBy[0]) || ''
      }
      
      var query = `ordering=${sortDesc && sortDesc[0] ? `${sort}` : `-${sort}`}&page=${page || 1}&page_size=${itemsPerPage || 20}&search=${this.search || ''}&tipo=${this.filters.tipo || ''}`
      if (this.filters.industry) {
        query += `&industry=${this.filters.industry}`
      }
      if (this.filters.rubro) {
        query += `&rubro=${this.filters.rubro}`
      }
      
      await excelCustomers(query)
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(response);
          link.setAttribute('download', `export_customers_${moment(new Date().toISOString()).format('DD-MM-yyyy_HH:mm')}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") notifications.showError('Error Exportando: Tiempo de Espera Excedido')
          else notifications.showError('Error Exportando')
        })
        .finally(() => {
          this.loading = false
        });
    }
  }
}
</script>

<style scoped>
.font-weight-black { font-weight: 900 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.h-44 { height: 44px !important; }
</style>